export class GoFailure {
    static ILLEGAL_KO = () => $localize `This move is a ko, you must play somewhere else before you can play in this intersection again.`;
    static CANNOT_PASS_AFTER_PASSED_PHASE = () => $localize `We are in the counting phase, you must mark stones as dead or alive or accept the current board by passing your turn.`;
    static CANNOT_ACCEPT_BEFORE_COUNTING_PHASE = () => $localize `You cannot accept before the counting phase.`;
    static OCCUPIED_INTERSECTION = () => $localize `This intersection is already occupied.`;
    static OCCUPIED_SPACE = () => $localize `This space is already occupied.`;
    static CANNOT_COMMIT_SUICIDE = () => $localize `You cannot commit suicide.`;
}
